import React, { useState, useContext } from "react";
import { NavigationContext } from "navigation-react";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
// import DashboardMainContent from "./DashboardMainContent";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const DashboardContent = () => {
  const [loading, setLoading] = useState(false);
  const { stateNavigator } = useContext(NavigationContext);
  const [token, setToken] = useState("");
  const userRoles = ls.get("currentuserrole");
  // eslint-disable-next-line no-unused-vars
  const [userRole, setUserRole] = useState(userRoles);

  const username = ls.get("username");

  const handleLogout = async () => {
    setLoading(true);
    try {
      const csrfResponse = await fetch(`${process.env.REACT_APP_SESSION_TOKEN_URL}`, {
        method: "GET",
        credentials: "include",
      });

      if (!csrfResponse.ok) {
        throw new Error("Failed to fetch CSRF token");
      }

      const tokenText = await csrfResponse.text();
      console.log("CSRF Token:", tokenText);
      setToken(tokenText);

      const response = await fetch(`/user/logout?_format=json&token=${token}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        console.log("Logout successful");
        ls.clear();
        stateNavigator.navigate("login");
      } else {
        throw new Error("Logout failed");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loadingindicator">
        <p>Loading...</p>
      </div>
    );
  }

  // const navigationRoleCTScan = () => {
  //   if (userRole.includes("content_editor")) {
  //     stateNavigator.navigate("ctscancontenteditorregister");
  //   } else if (userRole.includes("assign_request")) {
  //     stateNavigator.navigate("ctscanrequestassignedregister");
  //   } else if (userRole.includes("requestor")) {
  //     stateNavigator.navigate("ctscanrequestregister");
  //   } else if (userRole.includes("radiologist_user_role")) {
  //     stateNavigator.navigate("ctscanreportregister");
  //   } else {
  //     stateNavigator.navigate("login");
  //   }
  // };

  return (
    <div className="dashboard-container">
      <DashboardContentHeader handleLogout={handleLogout} username={username} />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        {/* <DashboardMainContent
          AddTitle="Dashboard Main"
          className="content-box"
          ctscaniconImage={faUserPlus}
          ctscaniconLable="CT Scan"
          // ctscanstateKey={"ctscanrequestregister"}
          xrayiconImage={faUserPlus}
          xrayiconLable="X-Ray"
          // xraystateKey="xraydashboard"
          ultrasoundiconImage={faUserPlus}
          ultrasoundiconLable="Ultrasound"
          // ultrasoundstateKey="ultrasounddashboard"
          ctScanonClick={navigationRoleCTScan}
        /> */}
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default DashboardContent;
